// extracted by mini-css-extract-plugin
export default {"topic":"styles-module--topic--1Vtbi","image-wrapper":"styles-module--image-wrapper--1BLpq","image":"styles-module--image--3Go-m"};